import { AuthenticatedTemplate } from '@azure/msal-react';
import { UseAuth } from './contexts/AuthContext';
import { ThemeProvider } from 'styled-components';
import { PageLayout } from './components/layout/PageLayout';
import { Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home/Home';
import { lightTheme } from '@tw/tw-component-library';

const App = () => {
  const { isAuthenticated, activeAccount, getAccessToken, login, logout } =
    UseAuth();
  return (
    <ThemeProvider theme={lightTheme}>
      <PageLayout
        isAuthenticated={isAuthenticated}
        activeAccount={activeAccount}
        login={login}
        logout={logout}
      >
        {isAuthenticated && (
          <AuthenticatedTemplate>
            <Routes>
              <Route
                path="/"
                element={
                  <Home
                    getAccessToken={getAccessToken}
                    account={activeAccount?.idToken}
                  />
                }
              />
            </Routes>
          </AuthenticatedTemplate>
        )}
      </PageLayout>
    </ThemeProvider>
  );
};

export default App;
